export default __webpack_public_path__ + "static/media/tinnova.411ff716.jpg";